import { getAxiosInstance } from "./axiosInstance";

// Create Technician
const createTechnician = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/technician/create/", data);
};

// Update Technician
const updateTechnician = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/technician/update/", data);
};

// List Technicians
const getTechnicianList = (params = {}) => {
  const http = getAxiosInstance();

  return http.get("/api/technician/list/", {
    params,
  });
};

const TechnicianService = {
  createTechnician,
  updateTechnician,
  getTechnicianList,
};

export default TechnicianService;